import { Component, Input, OnInit, SimpleChanges } from "@angular/core";

@Component({
  selector: "impact-item",
  templateUrl: "./impact-item.component.html",
  styleUrls: ["./impact-item.component.scss"],
})
export class ImpactItemComponent {
  @Input() target: number = 0;
  @Input() loss: number = 0;
  @Input() additional: number = 0;
  @Input() max: number = 0;
  total: number = 0;
  targetWidth: number = 0;
  lossWidth: number = 0;
  additionalWidth: number = 0;
  targetCharLength: number = 0;
  targetCharPercent: number = 0;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes.loss &&
        changes.loss.previousValue !== changes.loss.currentValue) ||
      (changes.additional &&
        changes.additional.previousValue !== changes.additional.currentValue)
    ) {
      this.loss = Math.round(this.loss);
      this.additional = Math.round(this.additional);
      const loss = Math.abs(this.loss);
      this.targetWidth = (this.target / this.max) * 50;
      this.lossWidth = (loss / this.max) * 50;
      this.additionalWidth = (this.additional / this.max) * 50;
      this.total = this.target - loss + this.additional;
      this.targetCharLength = (this.target.toString().length + 3) * 9.5;
      this.targetCharPercent = (this.target.toString().length + 3) * 14;
    }
  }
}
